module.exports = __webpack_public_path__ + "static/media/Subscribe01-1040-400.a1bc13e5.jpg";